import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

const LineItem = observer(
  ({ description, price, footer, descriptionError, priceError, removable, onChangeCallback, onRemoveCallback }) => (
    <div className="line-item">
      <div className="row">
        <span>
          <input
            type="text"
            className={`description${descriptionError ? " error" : ""}`}
            placeholder="description"
            value={description}
            onChange={event => onChangeCallback("description", event.target.value)}
          />
        </span>
        <span className="spacer" />
        <span>
          $&nbsp;
          <input
            type="text"
            className={`price${priceError ? " error" : ""}`}
            placeholder="price"
            /* cast to empty string in case value is null since input value must be of type string */
            value={price || ""}
            /* cast to null in case value equals to empty string, this is because the price must be a number or null */
            onChange={event => onChangeCallback("price", event.target.value || null)}
          />
        </span>
        <span className="spacer" />
        {removable ? (
          <a
            href="#"
            onClick={event => {
              event.preventDefault();
              onRemoveCallback();
            }}
          >
            <i className="delete icon" style={{ textDecoration: "none" }} />
          </a>
        ) : null}
      </div>
      <div className="row">{footer}</div>
    </div>
  ),
);

LineItem.propTypes = {
  description: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  footer: PropTypes.node,
  descriptionError: PropTypes.bool,
  priceError: PropTypes.bool,
  removable: PropTypes.bool,
  onChangeCallback: PropTypes.func.isRequired,
  onRemoveCallback: PropTypes.func.isRequired,
};

export default LineItem;
